import { render, staticRenderFns } from "./TranslationUploadBatchView.vue?vue&type=template&id=1859fa62"
import script from "./TranslationUploadBatchView.vue?vue&type=script&lang=js"
export * from "./TranslationUploadBatchView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports